var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-select",on:{"click":_vm.toggleSelect}},[(!_vm.props.isSelected)?_c('div',{staticClass:"radio-no-select"}):_c('Icon',{attrs:{"file":_vm.radioIcon,"size":'20px'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }